const trans = {
    '1': {
        'Mon': 'Pon',
        'Tue': 'Uto',
        'Wed': 'Sri',
        'Thu': 'Čet',
        'Fri': 'Pet',
        'Sat': 'Sub',
        'Sun': 'Ned',
        'Accept': 'Odaberi',
        'Select month': 'Odaberi mjesec',
        'Select year': 'Odaberi godinu',
        'Select time': 'Odaberi vrijeme'
    },
    '2': {
        'Mon': 'Mon',
        'Tue': 'Tue',
        'Wed': 'Wed',
        'Thu': 'Thu',
        'Fri': 'Fri',
        'Sat': 'Sat',
        'Sun': 'Sun',
        'Accept': 'Select',
        'Select month': 'Select month',
        'Select year': 'Select year',
        'Select time': 'Select time'
    },
    '3': {
        'Mon': 'Mo.',
        'Tue': 'Di.',
        'Wed': 'Mi.',
        'Thu': 'Do.',
        'Fri': 'Fr.',
        'Sat': 'Sa.',
        'Sun': 'So.',
        'Accept': 'Auswählen',
        'Select month': 'Monat auswählen',
        'Select year': 'Jahr auswählen',
        'Select time': 'Zeit auswählen'
    }
};

const localTranslate = (langId, key) => {
    if (trans[langId][key]) {
        return trans[langId][key];
    }

    return key;
}

export default localTranslate;